jQuery(document).ready(function() {
    if(!is_dev) {
        return false;
    }
    // open_api_explorer();
});
function open_api_explorer() {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/explorer/view',
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();

            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}